import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getStLouisStructuredData() {
  const url = "https://restorehair.com/locations/missouri/st-louis/";
  const description =
    "Find out about your hair transplant options in St. Louis with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("st-louis", url, description),
    locationPageCrumbs(url, "St. Louis"),
  ];
}
